import React, { FC, useCallback, useEffect, useState } from 'react';

import { TabPanel } from 'devextreme-react';
import $createDataSource from 'utils/create-data-souce-instance';

type TabsFactoryProps = {
  setActiveTab: (tab: number) => void;
  activeTab: number;
};

const itemTitleRender = (tab: { name: string; index: number }) => {
  return <span>{tab.name}</span>;
};

const TabsFactory: FC<TabsFactoryProps> = ({ setActiveTab }) => {
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const [tabs, setTabs] = useState([]);

  const unitData = useCallback(async () => {
    const result = await $createDataSource('/v1/Factory/fullNames', 'id', {
      pageSize: 120,
      paginate: true,
    }).load();
    setTabs(result.filter((item) => item.parentId).sort((a, b) => a.id - b.id));
  }, []);

  useEffect(() => {
    unitData();
  }, [unitData]);

  return (
    <TabPanel
      height="auto"
      items={tabs}
      selectedIndex={selectedIndex}
      onOptionChanged={(e) => {
        if (e.name === 'selectedIndex') {
          setSelectedIndex(e.value);
        }
      }}
      itemTitleRender={itemTitleRender}
      animationEnabled={false}
      //@ts-ignore
      onSelectionChanged={(e) => setActiveTab(e.addedItems![0].id)}
    />
  );
};
export default TabsFactory;
